(ns storrito.calendly.links
  "The Calendly booking links used by the call CTAs across the app.
   Keep every booking URL here so event slugs can be changed in one
   place."
  (:require [lambdaisland.uri :as uri]))

(def events
  "Semantic CTA name -> Calendly event slug."
  {:connect-help "help-connecting"
   :demo-call "storrito-demo-call"
   :solutions "storritiosolutions"
   :feature-request "your-storrito-story"})

(defn url
  "Booking URL for `event` (a key of `events`). `utm-source` identifies
   the CTA placement for click attribution. `org-uuid` (optional) is
   the booking organization's `:organization/uuid`; Calendly stores it
   as the invitee's `utm_content`, so a booking can be joined to the
   customer no matter which e-mail address the customer books with.
   The uuid is already public as the tenant subdomain, put nothing else
   in there."
  ([event utm-source]
   (url event utm-source nil))
  ([event utm-source org-uuid]
   (when-not (contains? events event)
     (throw (ex-info "Unknown Calendly event"
                     {:event event
                      :valid-events (keys events)})))
   (str "https://calendly.com/storrito-customer-success/"
        (get events event)
        "?utm_source=" (uri/query-encode utm-source)
        (when org-uuid
          (str "&utm_content=" (uri/query-encode (str org-uuid)))))))

(comment
  (url :connect-help "welcome-screen")
  ;; => "https://calendly.com/storrito-customer-success/help-connecting?utm_source=welcome-screen"
  (url :connect-help "welcome-screen" #uuid "8d3a5e7c-2f4b-4a1e-9c6d-0b1a2c3d4e5f")
  ;; => "https://calendly.com/storrito-customer-success/help-connecting?utm_source=welcome-screen&utm_content=8d3a5e7c-2f4b-4a1e-9c6d-0b1a2c3d4e5f"
  )
